import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["xlink:href"];
const _hoisted_2 = ["data-icon"];
import { propTypes } from '@/utils/propTypes';
import Iconify from '@purge-icons/generated';
import { useDesign } from '@/hooks/web/useDesign';
import { computed, nextTick, ref, unref, watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'Icon'
  },
  __name: 'Icon',
  props: {
    // icon name
    icon: propTypes.string,
    // icon color
    color: propTypes.string,
    // icon size
    size: propTypes.number.def(16),
    // icon svg class
    svgClass: propTypes.string.def('')
  },
  setup(__props) {
    const {
      getPrefixCls
    } = useDesign();
    const prefixCls = getPrefixCls('icon');
    const props = __props;
    const elRef = ref(null);
    const isLocal = computed(() => props.icon?.startsWith('svg-icon:'));
    const symbolId = computed(() => {
      return unref(isLocal) ? `#icon-${props.icon.split('svg-icon:')[1]}` : props.icon;
    });
    const getIconifyStyle = computed(() => {
      const {
        color,
        size
      } = props;
      return {
        fontSize: `${size}px`,
        height: '1em',
        color
      };
    });
    const getSvgClass = computed(() => {
      const {
        svgClass
      } = props;
      return `iconify ${svgClass}`;
    });
    const updateIcon = async icon => {
      if (unref(isLocal)) return;
      const el = unref(elRef);
      if (!el) return;
      await nextTick();
      if (!icon) return;
      const svg = Iconify.renderSVG(icon, {});
      if (svg) {
        el.textContent = '';
        el.appendChild(svg);
      } else {
        const span = document.createElement('span');
        span.className = 'iconify';
        span.dataset.icon = icon;
        el.textContent = '';
        el.appendChild(span);
      }
    };
    watch(() => props.icon, icon => {
      updateIcon(icon);
    });
    return (_ctx, _cache) => {
      const _component_ElIcon = _resolveComponent("ElIcon");
      return _openBlock(), _createBlock(_component_ElIcon, {
        class: _normalizeClass(_unref(prefixCls)),
        color: __props.color,
        size: __props.size
      }, {
        default: _withCtx(() => [isLocal.value ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          class: _normalizeClass(getSvgClass.value)
        }, [_createElementVNode("use", {
          "xlink:href": symbolId.value
        }, null, 8, _hoisted_1)], 2)) : (_openBlock(), _createElementBlock("span", {
          key: 1,
          ref_key: "elRef",
          ref: elRef,
          class: _normalizeClass(_ctx.$attrs.class),
          style: _normalizeStyle(getIconifyStyle.value)
        }, [_createElementVNode("span", {
          class: _normalizeClass(getSvgClass.value),
          "data-icon": symbolId.value
        }, null, 10, _hoisted_2)], 6))]),
        _: 1
      }, 8, ["class", "color", "size"]);
    };
  }
});